import _ from 'lodash'

import { LevelPlaySorted as Activity } from '.'

export const SLUG = 'sorted'
export const activity = {
  SLUG,
  Component: Activity,
  handleAnswerCallback: props => {
    let { answer, activity } = props
    let {
      save_answer: saveAnswer = false,
      correct_words: correctWords = [],
      ignore_order: ignoreOrder = false
    } = activity.meta

    correctWords = _.isArray(correctWords)
      ? correctWords
      : correctWords.split(';')
    let answerIsCorrect = ignoreOrder
      ? _.isEqual(_.compact(answer).sort(), _.compact(correctWords).sort())
      : _.isEqual(_.compact(answer), _.compact(correctWords))

    return { answer, answerIsCorrect, skipValidation: saveAnswer }
  }
}
